module.exports = __webpack_public_path__ + "static/media/iphone2.08746fe1.png";